import React from 'react';
import {
  Dialog,
  DialogActions,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from '@mui/material';
import { MdClose } from 'react-icons/md';
import useAdminsApi from '../../api/useAdminsApi';

const AddRoleDialog = ({ open, onClose, renderCount, setRenderCount }) => {
  const [status, setStatus] = React.useState('active');
  const [roleName, setRoleName] = React.useState('');
  const [description, setDescription] = React.useState('');
  const { addRole, loading: addLoading } = useAdminsApi();

  const handleStatusChange = (event) => {
    setStatus(event.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formData = {
      role: roleName,
      description,
      is_live: status === 'active',
    };
    await addRole(formData);
    setRenderCount(renderCount + 1)
    handleReset();
    onClose();
  };

  const handleReset = () => {
    setRoleName('');
    setDescription('');
    setStatus('active');
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth PaperProps={{ sx: { borderRadius: '16px' } }}
    >
      <form onSubmit={e => handleSubmit(e)}>
        <div className="card mb-0 rounded-3">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h6 className="card-title mb-0">Add Role</h6>
            <button type="button" className="btn btn-sm btn-light p-1" onClick={handleReset}>
              <MdClose size={18} />
            </button>
          </div>

          <div className="card-body">
            <div className="mb-3">

              <label className="form-label fw-semibold text-primary-light text-sm mb-1">
                Role Name
              </label>
              <input
                type="text"
                className="form-control radius-8"
                placeholder="Enter Role Name"
                value={roleName}
                onChange={(e) => setRoleName(e.target.value)}
              />
            </div>

            <div className="mb-3">
              <label className="form-label fw-semibold text-primary-light text-sm mb-1">
                Description
              </label>
              <textarea
                className="form-control"
                rows="4"
                placeholder="Write some text"
                value={description}
                onChange={(e) => setDescription(e.target.value)}
              />
            </div>

            <FormControl component="fieldset" margin="normal">
              <label className="form-label fw-semibold text-primary-light text-sm">
                Status
              </label>
              <RadioGroup row value={status} onChange={handleStatusChange}>
                <FormControlLabel
                  value="active"
                  control={<Radio color="success" />}
                  label="Active"
                />
                <FormControlLabel
                  value="inactive"
                  control={<Radio color="error" />}
                  label="Inactive"
                />
              </RadioGroup>
            </FormControl>

            <DialogActions sx={{ mt: 3 }}>
              <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                <button
                  type="button"
                  onClick={handleReset}
                  className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={addLoading}
                  className="btn btn-primary border border-primary-600 text-md px-48 py-12 radius-8"
                >
                  {addLoading ? (
                    <span className="spinner-border spinner-border-sm" />
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </DialogActions>
          </div>
        </div>
      </form>
    </Dialog>
  );
};

export default AddRoleDialog;
